import axios from "axios";
import store from "./store";

const axiosClient = axios.create({
    baseURL: "https://backend.sultanflowersextractpalace.com/api/"
})
axiosClient.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${store.state.user.token}`
    return config
})


axiosClient.interceptors.response.use(response => {
    return response
}, error => {

    if (error.response.status === 401) {
        store.commit('setToken', null)
    }
    throw error;
    //console error will call then not catch
})

export default axiosClient
